import React, { useState, useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Spinner,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Instructions from "./instructions";
import usePermission from "hooks/usePermission";
import Select from "react-select";
import {
  getSettings,
  uploadFile,
  updateGameSettings,
  getCoinsListApi,
  updateWelcomeBonusSettings,
} from "store/actions";
import Dropzone from "components/Dropzone";
import LoadingButton from "../../../components/shared/LoadingButton";

const WelcomeBonus = () => {
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);
  const { coinsList, loadingCoins } = useSelector(({ Game }) => Game);
  const [options, setOptions] = useState([]);
  const { hasPermission } = usePermission();
  const permissions = {
    add: false,
    edit: hasPermission("edit_verification_bonus_setting"),
    delete: false,
  };

  useEffect(() => {
    dispatch(getCoinsListApi({}));
  }, [dispatch]);

  useEffect(() => {
    let data = [];
    if (coinsList?.length) {
      data = coinsList.map((item) => ({
        label: item.name,
        value: item.name,
        symbol: item.symbol,
        icon: item.icon,
      }));
    }
    //  else {
    //   data = (cryptoList).map((item) => ({ label: item.name, value: item.name }));
    // }
    setOptions(data);
  }, [coinsList]);

  console.info(options, "OPTIONS");

  const findDefaultOption = (value) => {
    console.info(value, "VALUESS");
    try {
      let abc = options.find((option) => option.label === value);
      console.info(abc, "findDefaultOption");
      return options.find((option) => option.label === value);
    } catch {
      return null;
    }
  };

  const [fields, setFields] = useState({
    coinName: "",
    coinSymbol: "",
    coinIcon: "",
    coinMinRange: 0,
    coinMaxRange: 0,
    btncCoin: 0,
    energyBalance: 0,
    status: "disabled",
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings?._id) {
      const welcomeBonus = settings.welcomeBonus;
      setFields(() => ({
        coinName: welcomeBonus?.coinName,
        coinSymbol: welcomeBonus?.coinSymbol,
        coinIcon: welcomeBonus?.coinIcon,
        coinGif: welcomeBonus?.coinGif,
        coinMinRange: welcomeBonus?.coinMinRange,
        coinMaxRange: welcomeBonus?.coinMaxRange,
        btncCoin: welcomeBonus?.btncCoin,
        energyBalance: welcomeBonus?.energyBalance,
        status: welcomeBonus?.status,
      }));
    }
  }, [settings]);

  const handleSelectChange = (selectedOption, fieldName) => {
    if (fieldName === "coinName") {
      setFields((prev) => ({
        ...prev,
        [fieldName]: selectedOption.value, // Store value, not label
        coinSymbol: selectedOption.symbol || "",
        coinIcon: selectedOption.icon || "",
      }));
    } else {
      setFields((prev) => ({
        ...prev,
        [fieldName]: selectedOption.value,
      }));
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFields((prev) => ({
      ...prev,
      [name]:
        name === "coinMinRange" || name === "coinMaxRange"
          ? Number(value) || ""
          : value,
    }));
  };

  const submit = async () => {
    dispatch(
      updateWelcomeBonusSettings({
        data: { ...fields },
      }),
    );
  };
  // console.info(fields, "FIELDS");
  // console.info("Permissions:", permissions);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <Col lg={8}>
                    <Instructions />
                  </Col>

                  <Col lg={8}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Coin Name</Label>
                          <Select
                            // menuIsOpen
                            className="mt-3"
                            value={findDefaultOption(fields?.coinName)}
                            name="coinName"
                            onChange={(selectedOption) =>
                              handleSelectChange(selectedOption, "coinName")
                            }
                            options={options}
                            isSearchable={true} // Enable search/filter functionality
                            placeholder="Select..."
                            id="coinName"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Coin Symbol</Label>
                          <Input
                            className="m-2"
                            type="text"
                            placeholder="coinSymbol"
                            value={fields?.coinSymbol}
                            name="coinSymbol"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Coin MinRange</Label>
                          <Input
                            className="m-2"
                            type="number"
                            placeholder="Coin MinRange"
                            value={fields?.coinMinRange}
                            name="coinMinRange"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Coin MaxRange</Label>
                          <Input
                            className="m-2"
                            type="number"
                            placeholder="Coin MaxRange"
                            value={fields?.coinMaxRange}
                            name="coinMaxRange"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Btnc Coin</Label>
                          <Input
                            className="m-2"
                            type="number"
                            placeholder="Btnc Coin"
                            value={fields?.btncCoin}
                            name="btncCoin"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Energy Balance</Label>
                          <Input
                            className="m-2"
                            type="number"
                            placeholder="Energy Balance"
                            value={fields?.energyBalance}
                            name="energyBalance"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Status</Label>
                          <select
                            name="status"
                            className="form-control"
                            value={fields?.status}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>

                      <Col>
                        <Label>Coin Icon</Label>
                        <div className="">
                          <div className="uploadImg position-relative d-inline-block">
                            {fields.coinIcon && (
                              <img
                                src={fields.coinIcon}
                                alt="Coin Icon"
                                className="img-fluid"
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  borderRadius: "8px",
                                }}
                              />
                            )}
                            <span className="icn position-absolute">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6.11125 13.125H8.88875C10.8394 13.125 11.815 13.125 12.5156 12.6657C12.8179 12.4675 13.0783 12.2118 13.2819 11.9132C13.75 11.2257 13.75 10.2675 13.75 8.35253C13.75 6.4369 13.75 5.4794 13.2819 4.7919C13.0783 4.49322 12.8179 4.23753 12.5156 4.0394C12.0656 3.74378 11.5019 3.63815 10.6387 3.60065C10.2269 3.60065 9.8725 3.2944 9.79187 2.89753C9.73026 2.60682 9.57017 2.3463 9.33865 2.16C9.10714 1.9737 8.81841 1.87303 8.52125 1.87503H6.47875C5.86125 1.87503 5.32937 2.30315 5.20812 2.89753C5.1275 3.2944 4.77312 3.60065 4.36125 3.60065C3.49875 3.63815 2.935 3.7444 2.48437 4.0394C2.18226 4.23757 1.92211 4.49326 1.71875 4.7919C1.25 5.4794 1.25 6.4369 1.25 8.35253C1.25 10.2675 1.25 11.225 1.71813 11.9132C1.92062 12.2107 2.18062 12.4663 2.48437 12.6657C3.185 13.125 4.16062 13.125 6.11125 13.125ZM7.5 5.79565C6.06187 5.79565 4.89562 6.94003 4.89562 8.3519C4.89562 9.7644 6.06187 10.9088 7.5 10.9088C8.93812 10.9088 10.1044 9.7644 10.1044 8.35253C10.1044 6.94003 8.93812 5.79565 7.5 5.79565ZM7.5 6.81815C6.6375 6.81815 5.9375 7.50503 5.9375 8.35253C5.9375 9.1994 6.6375 9.88628 7.5 9.88628C8.3625 9.88628 9.0625 9.1994 9.0625 8.35253C9.0625 7.50503 8.3625 6.81815 7.5 6.81815ZM10.4512 6.3069C10.4512 6.0244 10.6844 5.79565 10.9725 5.79565H11.6662C11.9537 5.79565 12.1875 6.0244 12.1875 6.3069C12.1862 6.44371 12.1306 6.57441 12.033 6.67027C11.9354 6.76613 11.8037 6.81932 11.6669 6.81815H10.9725C10.9047 6.81881 10.8374 6.80611 10.7746 6.78078C10.7117 6.75544 10.6544 6.71797 10.606 6.67049C10.5576 6.62302 10.519 6.56647 10.4925 6.50409C10.4659 6.4417 10.4519 6.3747 10.4512 6.3069Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </Col>

                      <Col className="">
                        <Label>Coin Gif</Label>
                        <div className="">
                          <div className="uploadImg position-relative d-inline-block">
                            {fields.coinGif && (
                              <img
                                src={fields.coinGif}
                                alt="Coin Gif"
                                className="img-fluid"
                                style={{
                                  maxWidth: "100px",
                                  maxHeight: "100px",
                                  borderRadius: "8px",
                                }}
                              />
                            )}
                            <span className="icn position-absolute">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6.11125 13.125H8.88875C10.8394 13.125 11.815 13.125 12.5156 12.6657C12.8179 12.4675 13.0783 12.2118 13.2819 11.9132C13.75 11.2257 13.75 10.2675 13.75 8.35253C13.75 6.4369 13.75 5.4794 13.2819 4.7919C13.0783 4.49322 12.8179 4.23753 12.5156 4.0394C12.0656 3.74378 11.5019 3.63815 10.6387 3.60065C10.2269 3.60065 9.8725 3.2944 9.79187 2.89753C9.73026 2.60682 9.57017 2.3463 9.33865 2.16C9.10714 1.9737 8.81841 1.87303 8.52125 1.87503H6.47875C5.86125 1.87503 5.32937 2.30315 5.20812 2.89753C5.1275 3.2944 4.77312 3.60065 4.36125 3.60065C3.49875 3.63815 2.935 3.7444 2.48437 4.0394C2.18226 4.23757 1.92211 4.49326 1.71875 4.7919C1.25 5.4794 1.25 6.4369 1.25 8.35253C1.25 10.2675 1.25 11.225 1.71813 11.9132C1.92062 12.2107 2.18062 12.4663 2.48437 12.6657C3.185 13.125 4.16062 13.125 6.11125 13.125ZM7.5 5.79565C6.06187 5.79565 4.89562 6.94003 4.89562 8.3519C4.89562 9.7644 6.06187 10.9088 7.5 10.9088C8.93812 10.9088 10.1044 9.7644 10.1044 8.35253C10.1044 6.94003 8.93812 5.79565 7.5 5.79565ZM7.5 6.81815C6.6375 6.81815 5.9375 7.50503 5.9375 8.35253C5.9375 9.1994 6.6375 9.88628 7.5 9.88628C8.3625 9.88628 9.0625 9.1994 9.0625 8.35253C9.0625 7.50503 8.3625 6.81815 7.5 6.81815ZM10.4512 6.3069C10.4512 6.0244 10.6844 5.79565 10.9725 5.79565H11.6662C11.9537 5.79565 12.1875 6.0244 12.1875 6.3069C12.1862 6.44371 12.1306 6.57441 12.033 6.67027C11.9354 6.76613 11.8037 6.81932 11.6669 6.81815H10.9725C10.9047 6.81881 10.8374 6.80611 10.7746 6.78078C10.7117 6.75544 10.6544 6.71797 10.606 6.67049C10.5576 6.62302 10.519 6.56647 10.4925 6.50409C10.4659 6.4417 10.4519 6.3747 10.4512 6.3069Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col md={6} />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end mt-3">
                          {/* {loading && (
                            <Spinner color="primary" className="mr-2" />
                          )}

                          <Button className="btn btn-primary" onClick={submit}>
                            Save Changes
                          </Button> */}

                          <LoadingButton
                            onClick={submit}
                            //   className={`btn btn-primary btn-lg
                            //    ${
                            //     is_block ? "btn-block" : ""
                            //   }`
                            // }
                            className="btn btn-primary btn-lg"
                            loading={loading}
                            disabled={loading}
                          >
                            {!loading ? (
                              <>
                                {/* <i className="fa fa-sign-in fa-lg fa-fw"></i> */}
                                Save Changes
                              </>
                            ) : (
                              ""
                            )}
                          </LoadingButton>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WelcomeBonus;
